'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var color = _ref.color,
      size = _ref.size,
      spacing = _ref.spacing,
      styles = _ref.styles;
  var calculateSpacing = _ref2.calculateSpacing,
      colors = _ref2.colors,
      scale = _ref2.scale,
      treatments = _ref2.treatments;
  return {
    root: (0, _merge2.default)(_extends({}, treatments.head, calculateSpacing(spacing, 'margin'), {
      fontSize: scale(size),
      color: color && colors[color]
    }), styles)
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/heading/styles.js
// module id = 840
// module chunks = 0